<div class="admin-page-container">
  <div class="page-header">
    <div class="header-left">
      <h1>Approval Requests</h1>
      <p>Review and manage pending department and scheme submissions</p>
    </div>
  </div>

  <div class="dashboard-stats-row">
    <div class="stat-card">
      <div class="stat-icon bg-orange"><i class="fa-solid fa-clock-rotate-left"></i></div>
      <div class="stat-info">
        <span class="label">Pending Review</span>
        <span class="value">{{ pendingCount() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-green"><i class="fa-solid fa-circle-check"></i></div>
      <div class="stat-info">
        <span class="label">Approved Today</span>
        <span class="value">{{ approvedToday() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-blue"><i class="fa-solid fa-file-invoice"></i></div>
      <div class="stat-info">
        <span class="label">Total Requests</span>
        <span class="value">{{ requests().length }}</span>
      </div>
    </div>
  </div>

  <app-data-table
    [title]="'Pending Approvals'"
    [data]="requests()"
    [columns]="columns"
    [loading]="loading()"
    (action)="handleTableAction($event)"
  ></app-data-table>
</div>

<!-- Review Modal -->
<app-admin-modal
  [isOpen]="isModalOpen()"
  [title]="'Review Request'"
  [subtitle]="'Review the details and decide whether to approve or reject'"
  [icon]="'fa-solid fa-magnifying-glass-chart'"
  [showFooter]="false"
  (close)="isModalOpen.set(false)"
>
  <div class="review-details" *ngIf="selectedRequest">
    <div class="detail-row">
      <span class="label">Status:</span>
      <app-status-badge [status]="selectedRequest.status"></app-status-badge>
    </div>
    <div class="detail-row">
      <span class="label">Requested By:</span>
      <span class="value">{{ selectedRequest.operatorUid }}</span>
    </div>
    
    <div class="data-preview">
      <h5>Data Preview</h5>
      <pre>{{ selectedRequest.payload | json }}</pre>
    </div>

    <div class="form-group mt-6">
      <label class="block text-xs font-bold text-slate-600 uppercase mb-2">Remarks</label>
      <textarea [(ngModel)]="remarks" rows="3" class="w-full p-3 border rounded-xl text-sm" placeholder="Add approval/rejection notes..."></textarea>
    </div>

    <div class="flex gap-4 mt-6">
      <button class="btn-reject flex-1" (click)="reject()" [disabled]="isSubmitting()">
        <i class="fa-solid fa-circle-xmark"></i> Reject
      </button>
      <button class="btn-approve flex-1" (click)="approve()" [disabled]="isSubmitting()">
        <i class="fa-solid fa-circle-check"></i> Approve
      </button>
    </div>
  </div>
</app-admin-modal>
